export default "__VITE_ASSET__71f219fd__"